import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext } from 'react';
const noop = () => {};
export const SwitcherExperienceTrackerContext = /*#__PURE__*/createContext({
  start: noop,
  success: noop,
  failure: noop,
  failureAll: noop,
  abort: noop,
  abortAll: noop,
  markStart: noop,
  markEnd: noop
});
export const useExperienceTracker = () => useContext(SwitcherExperienceTrackerContext);
export const withExperienceTracker = Component => {
  const WithExperienceTracker = props => {
    const experienceTracker = useExperienceTracker();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      experienceTracker: experienceTracker
    }));
  };
  WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
  return WithExperienceTracker;
};